(ns frontend.ui.page.lp-portal.home-link
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.page.lp-portal.report.style :as style]
   [reitit.frontend.easy :as reitit-e]
   [common.localization :as loc]
   [frontend.lp-portal.routes :as routes]))

(defn home-link
  []
  [:a
   {:href  (reitit-e/href ::routes/landing-page)
    :class (<class style/home-link)}
   [:i.fal.fa-arrow-left.pr-2]
   (loc/tr :home)])
